export { ConfirmationModal } from './EditTabsConfirmationModal';
export { default } from './EditTabsConfirmationModal';
